import { Text, TextProps } from "@mantine/core"

export const Missing = (props: TextProps) => {
  return (
    <Text span c="gray" {...props}>
      -
    </Text>
  )
}
